import { data } from "./planner.data";
import { start } from "./planner.start";
import { table } from "./planner.table";

var planner = (function () {    
    const slider = document.getElementById('slider');

    const newData = new CustomEvent("newData", {});
            
    function initSlider() 
    {
        noUiSlider.create(slider, {
            start: [32, 38],
            connect: true,
            range: {
                'min': 1,
                'max': 38
            },
            step: 1,
            //tooltips: true,
                format: {
                // 'to' the formatted value. Receives a number.
                to: function (value) {
                    return Math.round(value);
                },
                // 'from' the formatted value.
                // Receives a string, should return a number.
                from: function (value) {
                    return Math.round(value);
                }
            },
            pips: {
                mode: 'steps',
                stepped: true,
                density: 4
            }
        });
    }

    function bindEvents()
    {        
        initSlider();

        slider.noUiSlider.on("change", function() {
            document.dispatchEvent(newData);
        });
    }
    
    function init() {
        table.init();
        start.init();        

        bindEvents();
    }

    return {
        init
    };
})();

addEventListener("DOMContentLoaded", (event) => 
{
    planner.init();
});

